import { CheckInCircle } from '@travel/icons/ui';
import { IconTextTag } from '@travel/ui';
import { cx } from '@travel/utils';
import { getIsFavoriteHandlerSuccess } from 'favoriteList/store/providerPlan/selectors';
import { useSelector } from 'react-redux';
import styles from './popup.module.scss';

type Props = {
  isFade: boolean;
  clickHandler: () => void;
  label: string;
};

const Popup = (props: Props) => {
  const { isFade, clickHandler, label } = props;
  const isFavoriteHandlerSuccess = useSelector(getIsFavoriteHandlerSuccess);
  return (
    <div
      className={cx(styles.popupContainer, isFade && styles.fadeOut)}
      data-testid="popup-container"
    >
      <div
        className={styles.textButtonContainer}
        data-testid={
          isFavoriteHandlerSuccess ? 'text-button-container' : 'error-text-button-container'
        }
      >
        <IconTextTag
          className={styles.textContainer}
          color="default"
          icon={<CheckInCircle color="white" />}
          label={
            <span className={styles.text}>
              {isFavoriteHandlerSuccess ? label : 'エラーが発生しました'}
            </span>
          }
        />
        {isFavoriteHandlerSuccess && (
          <button
            data-testid="rollback-button"
            onClick={() => clickHandler()}
            className={styles.buttonContainer}
          >
            <span className={styles.buttonText}>元に戻す</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Popup;
